export default __webpack_public_path__ + "static/media/screen3.3ae13f9c.png";